import { FilterOption } from '@companion-professional/components';
import { CheckupTag, LocationCheckupTags } from '@companion-professional/dctypes';
import { snakeToSentenceCase } from '@companion-professional/webutils';
import { defaultTagBadge, tagBadgeDisplay } from './tagBadgeDisplay';

// locationFilterOptions are all the locations that can be filtered by in the checkup table.  The tagBadgeDisplay is
// used to display a custom icon for each location.  If a location is not in the tagBadgeDisplay mapping, the
// defaultTagBadge icon will be used.
export const locationFilterOptions: FilterOption<CheckupTag>[] = LocationCheckupTags.map((locationTag) => {
  return {
    value: locationTag,
    label: snakeToSentenceCase(locationTag),
    icon:
      tagBadgeDisplay?.[locationTag] && Object.keys(tagBadgeDisplay).includes(locationTag)
        ? tagBadgeDisplay[locationTag].icon
        : defaultTagBadge.icon
  };
});
